module.exports = __webpack_public_path__ + "p6_img3.jpg?99ba1ab798b85d7e741746da629a7226";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img3.jpg
// module id = 181
// module chunks = 0